import { useRecoilValue } from 'recoil';

import { FullScreen } from '../../components/FullScreen';
import { ControlPanel } from '../../entities/dailyPlan/grid';
import { FontSizeControl, useGridScale } from '../../features/grid-settings';
import useExportToExcelRowsFromGrid from '../../hooks/useExportToExcelRowsFromGrid';
import { EntitiesPageWrapper } from '../../modules/EntitiesGrid';
import { DailyTasksGrid } from '../../modules/Tasks';
import { useImportDailyTasksFromExcel } from '../../modules/Tasks/state/dailyTasks';
import { useDefaultTasksGridSettings } from '../../modules/Tasks/state/tasks';
import { useExportToExcelDaily } from '../../state/export';
import { userEventSettings } from '../../state/user';

const DailyPlan = () => {
  const userEventSetting = useRecoilValue(userEventSettings);
  const scale = useGridScale('drs');
  const { ref: gridRef, ...gridDefaultSettings } = useDefaultTasksGridSettings({
    compact: userEventSetting.drsGridSettings.viewMode === 'compact',
    scale,
  });
  const { execute: exportToExcel } = useExportToExcelDaily();
  const exportToExcelCallback = useExportToExcelRowsFromGrid(gridRef, exportToExcel);
  const { execute: importFromExcelCallback, loading: loadingImportFromExcel } = useImportDailyTasksFromExcel();

  const onImportFromExcel = (file: File) => {
    importFromExcelCallback(file);
  };

  return (
    <FullScreen>
      <EntitiesPageWrapper>
        <ControlPanel
          onExportToExcel={exportToExcelCallback}
          onImportFromExcel={onImportFromExcel}
          loadingImportFromExcel={loadingImportFromExcel}
          fontSizeControl={<FontSizeControl gridType='drs' />}
        />
        <DailyTasksGrid gridRef={gridRef} scale={scale} {...gridDefaultSettings} />
      </EntitiesPageWrapper>
    </FullScreen>
  );
};

export default DailyPlan;
